import {
  Directive,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';
import { NotificationService } from 'src/app/Service/notification.service';
import { HelperService } from 'src/app/utils/helper.service';

@Directive({
    selector: '[ngFileUpload]',
    standalone: false
})
export class NgFileUploadDirective {
  @Input() maxSize: number = 52428800; // 50MB in bytes
  @Input() accept = ''; // 50MB in bytes
  @Output() uploaded = new EventEmitter<any>();
  @Output() uploadProfile = new EventEmitter<any>();

  constructor(private notify: NotificationService,private helper: HelperService) {}

  @HostListener('change', ['$event']) handleImageUpload(
    files: any
  ) {
    const fileList: File[] = Array.from(files.target.files);    
    if (this.accept) {
      const acceptType=this.accept=='image/*'?this.helper.imageFormates:this.accept.split(',').map(i=>i.trim())
      if(!fileList.map(i=>i.name.toLowerCase()).every(i=>acceptType.some(a=>i.endsWith(a.toLowerCase())))){
        this.notify.showError(
          'Please choose suggested file types : '+ acceptType.join(',')
        );
        return;
      }else if (this.maxSize && fileList.find((i) => i.size > this.maxSize)) {
        this.notify.showError(
          'File size exceeds limit. Maximum allowed size is 50MB.'
        );
        return;
      }else{
        this.uploaded.emit(fileList.length > 1 ? files.target.files : files.target.files.item(0));
        this.uploadProfile.emit(files);
      }      
    }else{
      this.uploaded.emit(fileList.length > 1 ? files.target.files : files.target.files.item(0));
      this.uploadProfile.emit(files);
    }
  }
}
